/**
 * Maps i18n language codes to Intl locale codes.
 * Ensures day-first date formatting (DD/MM/YYYY) by mapping
 * 'en' to 'en-GB' instead of the US default 'en-US'.
 */
const LOCALE_MAP: Record<string, string> = {
  en: 'en-GB',
};

/**
 * Returns the Intl-compatible locale for the given i18n language.
 * Use this everywhere dates or numbers are formatted with Intl APIs
 * to ensure consistent formatting across the application.
 */
export function getIntlLocale(language: string): string {
  return LOCALE_MAP[language] ?? language;
}
